import React, { useEffect } from "react";
import Modal from "react-bootstrap/Modal";

const ChiTietMauThuChi = (props) => {
    const { chitietMauThuChi, showModalChiTietMauThuChi, data } = props;
    const { showModalMauThuChi } = chitietMauThuChi;
    const { ContractId, ContractName, ContractContent } = data;
    // console.log("data: ", data);

    // Close the modal when Escape key is pressed
    const handleKeyDown = (event) => {
        if (event.key === "Escape") {
            showModalChiTietMauThuChi();
        }
    };

    useEffect(() => {
        // Add keydown event listener when modal is open
        if (showModalMauThuChi) {
            document.addEventListener("keydown", handleKeyDown);
        }
        // Cleanup event listener on unmount or when modal is closed
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [showModalMauThuChi]); // Effect runs when showModalLog changes

    return (
        <>
        <Modal
            show={showModalMauThuChi}
            dialogClassName="modal-90w"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-new modal fade text-left"
        >
            <Modal.Header>
                <h4 className="modal-title color7-bold" id="myModalLabel16">
                    <span className="btn-icon-right">
                        <img src="/app-assets/images/icon-hop-dong-cho-duyet.png" />
                    </span>
                    Xem mẫu thu chi
                </h4>
                <button
                    type="button"
                    className="close-popup-new"
                    onClick={showModalChiTietMauThuChi}
                >
                    <img src="/app-assets/images/icon-dong-popup-v2.png" />
                </button>
            </Modal.Header>
            <Modal.Body className="">
                <div className="form form-horizontal">
                    <div className="form-body">
                        <div className="form-group">
                            <label className="label-control color7-bold" style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: 8 }}>
                                Tên mẫu thu chi
                            </label>
                            <input
                                type="text"
                                className="form-control input-sm"
                                value={ContractName}
                                readOnly
                                style={{ fontSize: '16px', height: '40px', marginBottom: 16 }}
                            />
                        </div>
                        <div className="form-body">
                            <div
                                dangerouslySetInnerHTML={{ __html: ContractContent }}
                            ></div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-new-main btn-closenew"
                    onClick={showModalChiTietMauThuChi}
                >
                    <span>
                        <i className="mdi mdi-close"></i>
                    </span>
                    &nbsp;  Đóng
                </button>
            </Modal.Footer>
        </Modal>
        </>
    );
};
export default ChiTietMauThuChi;
